import { callAuthAPI } from 'react-morel-auth';
import { PutAppDetail } from '../../../../../types/app';

export const putApp = (appId: string | undefined, partialApp: Partial<PutAppDetail>) => {
  return callAuthAPI('/system/applications/' + appId, '', {
    method: 'PUT',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(partialApp),
  });
};
